import Swal from 'sweetalert2'

export const formatRupiah = (value) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(value);
  };

 export const alertsucces = (title,text,icon) => {
          Swal.fire({
              title: title,
              text: text,
              icon: icon
            });
      }

// export const calculateAdminFee = (amountValue) => {
        
//     if (isNaN(amountValue)) {
//         return 0;
//     }
    
//     let fee = 0;
    
//     if (amountValue >= 1 && amountValue <= 299999) {
//         fee = 5000;
//     } else if (amountValue >= 300000 && amountValue <= 499999) {
//         fee = 7000;
//     } else if (amountValue >= 500000 && amountValue <= 999999) {
//         fee = 10000;
//     } else if (amountValue >= 1000000 && amountValue <= 4999999) {
//         fee = 20000;
//     } else if (amountValue >= 5000000 && amountValue <= 9999999) {
//         fee = 50000;
//     } else if (amountValue >= 10000000 && amountValue <= 19999999) {
//         fee = 100000;
//     } else if (amountValue > 20000000) {
//         fee = amountValue * 0.0075 ;
//     }

// return fee;

// };

export const calculateAdminFee = (amountValue) => {
        
  if (isNaN(amountValue)) {
      return 0;
  }
  
  let fee = 0;
  
  if (amountValue >= 1 && amountValue <= 1000000) {
      fee = 0;
  }else if (amountValue > 1000000) {
      fee = 20000;
  }

return fee;

};

// export const pricingData = [
//     {
//       title: "Biaya Transaksi",
//       range: "10K - 299K",
//       price: "5K",
//     },
//     {
//       title: "Biaya Transaksi",
//       range: "300K - 499K",
//       price: "7K",
//     },
//     {
//       title: "Biaya Transaksi",
//       range: "500K - 999K",
//       price: "10K",
//     },
//     {
//       title: "Biaya Transaksi",
//       range: "1JT - 4,9JT",
//       price: "20K",
//     },
//     {
//       title: "Biaya Transaksi",
//       range: "5JT - 9,9JT",
//       price: "50K",
//     },{
//       title: "Biaya Transaksi",
//       range: "10JT - 19,9JT",
//       price: "100K",
//     },
//     {
//       title: "Biaya Transaksi",
//       range: "20JT - Seterusnya",
//       price: "0,75%",
//     },
  
//     // Tambahkan data lainnya sesuai kebutuhan
//   ];

  export const pricingData = [
    {
      title: "Biaya Transaksi",
      range: "10K - 1JT",
      price: "Free",
    },
    {
      title: "Biaya Transaksi",
      range: "1JT - Seterusnya",
      price: "20K",
    }
    // Tambahkan data lainnya sesuai kebutuhan
  ];